import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e33b16a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Zones <have> Dimensions", -1))
const _hoisted_2 = { class: "splash" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"24px"} }, "Select a Zone", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select which Dimensions are enabled for that Zone", -1))
const _hoisted_5 = { ref: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kendo_ddl = _resolveComponent("kendo-ddl")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _hoisted_3,
          _createVNode(_component_kendo_ddl, {
            class: "ddl",
            "data-items": _ctx.items,
            "default-item": 'Zone',
            "text-field": 'Name',
            "data-item-key": 'Id',
            filterable: true,
            onFilterchange: _ctx.filterChange,
            onChange: _ctx.selectZone
          }, null, 8, ["data-items", "onFilterchange", "onChange"])
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, null, 512)
    ])
  ], 64))
}